import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon3: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 14.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 14 20" width={width} height={height} {...props}>
      <Path
        d="M7.57576 3.00444L9.90255 6.96085C10.0062 7.13632 10.2143 7.60485 10.2945 8.23578C10.3356 8.56338 10.3431 8.93578 10.2824 9.33338C10.3599 9.24098 10.4327 9.14483 10.5008 9.0459C10.9423 8.4047 11.1999 7.63192 11.1999 6.79938C11.1999 4.70032 9.55815 2.97738 7.46655 2.80005C7.50015 2.86912 7.53656 2.93724 7.57576 3.00444Z"
        fill="#F3123C"
      />
      <Path
        d="M8.70618 8.19286L6.98605 5.3611C6.50911 4.57524 6.41764 3.64192 6.71351 2.80005C4.52857 2.93352 2.80005 4.65924 2.80005 6.7695C2.80005 7.38644 2.94751 7.96977 3.21164 8.4915C3.23591 8.5391 3.26112 8.58671 3.28725 8.63338L3.29565 8.64739C3.32459 8.69873 3.35445 8.74911 3.38525 8.79858L3.99285 9.81779C4.03391 9.90179 4.07872 9.98391 4.12819 10.0651L6.51005 13.9851C6.69112 14.2847 6.81712 14.6048 6.88619 14.9334L6.98605 14.7691C7.57591 13.7994 7.57591 12.6038 6.98605 11.6331L6.42604 10.7119L5.07458 8.48683C5.01671 8.3907 4.96538 8.29273 4.91872 8.19286C4.49779 7.28473 4.55191 6.2319 5.08111 5.3611L5.18005 5.19684C5.25005 5.52537 5.37511 5.84553 5.55711 6.14513L6.67058 7.97818L6.80125 8.19286L8.24231 10.5654L8.41498 10.8491C8.59698 11.1487 8.72204 11.4689 8.79204 11.7974L8.89098 11.6331C9.18591 11.1478 9.33338 10.6055 9.33338 10.0642C9.33338 9.52284 9.18591 8.98152 8.89098 8.49712L8.70618 8.19286Z"
        fill="#F3123C"
      />
      <Path
        d="M7 19.6L1.05654 10.346C1.0528 10.3413 1.04999 10.3367 1.04719 10.332L0.919333 10.1332C0.6412 9.65439 0.419997 9.14572 0.265063 8.61558C0.0895968 8.01545 0 7.3948 0 6.77133C0 6.65653 0.00279487 6.53986 0.0093282 6.42413C0.198795 2.82706 3.26666 0.00466666 6.99532 0H7.00559C10.7343 0.0056 13.8021 2.82706 13.9907 6.42413C13.9972 6.53893 14 6.6556 14 6.77133C14 7.378 13.9151 7.9828 13.748 8.56987C13.5921 9.1168 13.3672 9.64039 13.0769 10.1295L13.0228 10.22C12.9836 10.2844 12.9425 10.3488 12.9005 10.4123L12.8352 10.5159L7 19.6ZM7 17.7333L11.7871 10.3628L12.0969 9.88399C12.4311 9.38932 12.684 8.84986 12.8483 8.2796C12.9929 7.77653 13.0667 7.25759 13.0667 6.73772C13.0667 6.63879 13.0639 6.53799 13.0583 6.43999C12.8949 3.35906 10.2405 0.942666 7.01307 0.933333H7C6.99626 0.933333 6.99253 0.933333 6.98973 0.933333C3.76133 0.940799 1.10507 3.35813 0.941735 6.43999C0.936135 6.53892 0.933333 6.63972 0.933333 6.73772C0.933333 7.27159 1.0108 7.80359 1.16293 8.31879C1.3272 8.87412 1.5764 9.40052 1.90307 9.88399L1.96 9.96987L2.21761 10.36L7 17.7333Z"
        fill="#F3123C"
      />
    </Icon>
  )
}
